// This is used for polymorphic json requests to the backend subscription/update api.
export enum SubscriptionUpdateType {
  UpdateSubscriptionStatus = 'status',
  UpdateSubscriptionServices = 'services',
  UpdateSubscriptionNotes = 'notes',
  UpdateSubscriptionLabel = 'label'
}
